// extracted by mini-css-extract-plugin
export default {"hitbox":"ElevationChart--hitbox--KMWyK"};